function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { createContext, useContext, useMemo } from 'react';
import cs from 'classnames';
import './InstrumentManagementForm.css';
import getDisplayName from '../../../getDisplayName';
import LikertWidget from '../../Widgets/LikertWidget';
import CheckboxWidget from '../../Widgets/CheckboxWidget';
import RadioWidget from '../../Widgets/RadioWidget';
import DateWidget from '../../Widgets/DateWidget';
import SortDirectionWidget from '../../../Tables/SortDirectionWidget';
import TextWidget from '../../Widgets/TextWidget';
import TextAreaWidget from '../../Widgets/TextareaWidget';
import ArrayFieldTemplate from '../../ArrayTemplate/ArrayTemplate';
import ObjectFieldTemplate from '../../ObjectFieldTemplate/ObjectFieldTemplate';
import RecordEditorForm, { getRecordEditorWidgets } from '../../RecordEditor/RecordEditorForm';
import RevealCodesContext from '../RevealCodesContext/RevealCodesContext';
import NodeCodeComponent from '../NodeCodeComponent/NodeCodeComponent';
var NodeDatasContext = createContext({});
var ParentIdContext = createContext([]);
function toNodeId(id) {
  return id && id.length ? id.indexOf('_') === 0 ? id.substring(1) : id : '';
}
function getQuestionId(id, parentIds) {
  var result = id;
  if (parentIds.length) {
    var parentIdsRegexPart = parentIds.map(function (id) {
      return "(".concat(id, "_?-?\\d?)");
    }).join('');
    var idsRegex = new RegExp("^".concat(parentIdsRegexPart, "(_\\D+.+_-?\\d+)$"));
    if (idsRegex.test(id)) {
      var matches = idsRegex.exec(id);
      var idPortion = matches && matches.length ? matches[matches.length - 1] : '';
      result = idPortion;
    }
  }
  return result;
}
var isNodeDatas = function isNodeDatas(tbd) {
  return tbd.code === undefined;
};
function getNodeDescriptor(id, parentIds, nodeDatas) {
  var componentData = nodeDatas;
  if (parentIds.length && componentData) {
    parentIds.forEach(function (parentId) {
      var _newComponentData;
      if (parentId !== undefined && parentId.length === 0) {
        _newComponentData = componentData;
      } else if (isNodeDatas(componentData)) {
        _newComponentData = componentData[toNodeId(parentId)];
      }
      if (_newComponentData) {
        var children = _newComponentData.children;
        if (children !== undefined) {
          componentData = children;
        }
      }
    });
  }
  var result = {
    code: '{{UNKNOWN_CODE}}'
  };
  if (componentData) {
    if (id !== undefined && id.length === 0) {
      result = componentData;
    } else if (isNodeDatas(componentData)) {
      result = componentData[toNodeId(getQuestionId(id, parentIds))];
    }
  }
  return result;
}
function wrapNodeCodeComponent(Component) {
  function Wrapper(_ref) {
    var nodeId = _ref.nodeId,
      parentIds = _ref.parentIds,
      label = _ref.label,
      nodeDatas = _ref.nodeDatas;
    var nodeData = useMemo(function () {
      return getNodeDescriptor(nodeId, parentIds, nodeDatas);
    }, [nodeId, parentIds, nodeDatas]);
    return /*#__PURE__*/React.createElement(Component, {
      label: label,
      nodeData: nodeData
    });
  }
  return function (props) {
    return /*#__PURE__*/React.createElement(Wrapper, props);
  };
}
var InstrumentManagementFormNodeCodeComponent = wrapNodeCodeComponent(NodeCodeComponent);
function wrapInstrumentManagementWidget(WrappedComponent) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var Wrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(Wrapper, _React$Component);
    function Wrapper() {
      _classCallCheck(this, Wrapper);
      return _possibleConstructorReturn(this, _getPrototypeOf(Wrapper).apply(this, arguments));
    }
    _createClass(Wrapper, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React.createElement(NodeDatasContext.Consumer, null, function (nodeDatas) {
          return /*#__PURE__*/React.createElement(ParentIdContext.Consumer, null, function (parentIds) {
            return /*#__PURE__*/React.createElement("div", {
              className: cs('_dm-form__code-wrapper', _defineProperty({}, "_dm-form__code-wrapper--".concat(additionalProps.type), additionalProps.type))
            }, /*#__PURE__*/React.createElement(WrappedComponent, _this.props), /*#__PURE__*/React.createElement(InstrumentManagementFormNodeCodeComponent, {
              label: _this.props.label || _this.props.schema.title,
              nodeId: _this.props.id,
              parentIds: parentIds,
              nodeDatas: nodeDatas
            }));
          });
        });
      }
    }]);
    return Wrapper;
  }(React.Component);
  Wrapper.displayName = "WrapTriggerFieldWidget(".concat(getDisplayName(WrappedComponent), ")");
  return function (props) {
    var revealCodes = useContext(RevealCodesContext);
    return revealCodes ? /*#__PURE__*/React.createElement(Wrapper, props) : /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
}
function ArrayTemplateParentIdProvider(_ref2) {
  var parentIds = _ref2.parentIds,
    WrappedComponent = _ref2.WrappedComponent,
    wrappedComponentProps = _ref2.wrappedComponentProps;
  var _parentIds = useMemo(function () {
    return [].concat(_toConsumableArray(parentIds), [getQuestionId(wrappedComponentProps.idSchema.$id, parentIds)]);
  }, [parentIds, wrappedComponentProps.idSchema.$id]);
  return /*#__PURE__*/React.createElement(NodeDatasContext.Consumer, null, function (nodeDatas) {
    return /*#__PURE__*/React.createElement(ParentIdContext.Provider, {
      value: _parentIds
    }, /*#__PURE__*/React.createElement("div", {
      className: "_dm-form__code-wrapper _dm-form__code-wrapper--component"
    }, /*#__PURE__*/React.createElement(InstrumentManagementFormNodeCodeComponent, {
      label: wrappedComponentProps.title,
      nodeId: wrappedComponentProps.idSchema.$id,
      parentIds: parentIds,
      nodeDatas: nodeDatas
    }), /*#__PURE__*/React.createElement(WrappedComponent, wrappedComponentProps)));
  });
}
function wrapArrayTemplate(WrappedComponent) {
  var Wrapper = /*#__PURE__*/function (_React$Component2) {
    _inherits(Wrapper, _React$Component2);
    function Wrapper() {
      _classCallCheck(this, Wrapper);
      return _possibleConstructorReturn(this, _getPrototypeOf(Wrapper).apply(this, arguments));
    }
    _createClass(Wrapper, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/React.createElement(ParentIdContext.Consumer, null, function (parentIds) {
          return /*#__PURE__*/React.createElement(ArrayTemplateParentIdProvider, {
            parentIds: parentIds,
            WrappedComponent: WrappedComponent,
            wrappedComponentProps: _this2.props
          });
        });
      }
    }]);
    return Wrapper;
  }(React.Component);
  Wrapper.displayName = "WrapTriggerFieldWidget(".concat(getDisplayName(WrappedComponent), ")");
  return function (props) {
    var revealCodes = useContext(RevealCodesContext);
    return revealCodes ? /*#__PURE__*/React.createElement(Wrapper, props) : /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
}
function ObjectTemplateParentIdProvider(_ref3) {
  var parentIds = _ref3.parentIds,
    WrappedComponent = _ref3.WrappedComponent,
    wrappedComponentProps = _ref3.wrappedComponentProps;
  var idSchema = wrappedComponentProps.idSchema;
  var showCode = useMemo(function () {
    var result = false;
    var hasId = idSchema.$id && idSchema.$id !== '';
    if (hasId) {
      if (parentIds.length) {
        var parentDsaRegex = new RegExp("^(".concat(parentIds.join(''), "_\\d+)$"));
        result = !parentDsaRegex.test(idSchema.$id);
      } else {
        result = true;
      }
    }
    return result;
  }, [parentIds, idSchema]);
  var _parentIds = useMemo(function () {
    return showCode ? [].concat(_toConsumableArray(parentIds), [getQuestionId(idSchema.$id, parentIds)]) : parentIds;
  }, [showCode, parentIds, idSchema]);
  var _label = useMemo(function () {
    return typeof wrappedComponentProps.title === 'object' ? wrappedComponentProps.title.text : wrappedComponentProps.title;
  }, [wrappedComponentProps.title]);
  return showCode ? /*#__PURE__*/React.createElement(NodeDatasContext.Consumer, null, function (nodeDatas) {
    return /*#__PURE__*/React.createElement(ParentIdContext.Provider, {
      value: _parentIds
    }, /*#__PURE__*/React.createElement("div", {
      className: "_dm-form__code-wrapper _dm-form__code-wrapper--component"
    }, /*#__PURE__*/React.createElement(InstrumentManagementFormNodeCodeComponent, {
      label: _label,
      nodeId: idSchema.$id,
      parentIds: parentIds,
      nodeDatas: nodeDatas
    }), /*#__PURE__*/React.createElement(WrappedComponent, wrappedComponentProps)));
  }) : /*#__PURE__*/React.createElement(WrappedComponent, wrappedComponentProps);
}
function wrapObjectTemplate(WrappedComponent) {
  var Wrapper = /*#__PURE__*/function (_React$Component3) {
    _inherits(Wrapper, _React$Component3);
    function Wrapper() {
      _classCallCheck(this, Wrapper);
      return _possibleConstructorReturn(this, _getPrototypeOf(Wrapper).apply(this, arguments));
    }
    _createClass(Wrapper, [{
      key: "render",
      value: function render() {
        var _this3 = this;
        return /*#__PURE__*/React.createElement(ParentIdContext.Consumer, null, function (parentIds) {
          return /*#__PURE__*/React.createElement(ObjectTemplateParentIdProvider, {
            parentIds: parentIds,
            WrappedComponent: WrappedComponent,
            wrappedComponentProps: _this3.props
          });
        });
      }
    }]);
    return Wrapper;
  }(React.Component);
  Wrapper.displayName = "WrapTriggerFieldWidget(".concat(getDisplayName(WrappedComponent), ")");
  return function (props) {
    var revealCodes = useContext(RevealCodesContext);
    return revealCodes ? /*#__PURE__*/React.createElement(Wrapper, props) : /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
}
var getInstrumentManagementWidgets = function getInstrumentManagementWidgets(triggerData) {
  var recordEditorWidgets = getRecordEditorWidgets(triggerData);
  return {
    checkbox: wrapInstrumentManagementWidget(CheckboxWidget, {
      type: 'checkbox'
    }),
    checkboxes: wrapInstrumentManagementWidget(recordEditorWidgets.checkboxes, {
      type: 'checkboxes'
    }),
    date: wrapInstrumentManagementWidget(DateWidget, {
      type: 'date'
    }),
    likert: wrapInstrumentManagementWidget(LikertWidget, {
      type: 'likert'
    }),
    radio: wrapInstrumentManagementWidget(RadioWidget, {
      type: 'radio'
    }),
    richtext: wrapInstrumentManagementWidget(recordEditorWidgets.richtext, {
      type: 'richtext'
    }),
    select: wrapInstrumentManagementWidget(recordEditorWidgets.select, {
      type: 'select'
    }),
    sort: wrapInstrumentManagementWidget(SortDirectionWidget, {
      type: 'sort'
    }),
    text: wrapInstrumentManagementWidget(TextWidget, {
      type: 'text'
    }),
    textarea: wrapInstrumentManagementWidget(TextAreaWidget, {
      type: 'textarea'
    }),
    file: wrapInstrumentManagementWidget(recordEditorWidgets.file, {
      type: 'file '
    })
  };
};
var InstrumentManagementArrayFieldTemplate = wrapArrayTemplate(ArrayFieldTemplate);
var InstrumentManagementObjectFieldTemplate = wrapObjectTemplate(ObjectFieldTemplate);
var InstrumentManagementForm = function InstrumentManagementForm(_ref4) {
  var nodeData = _ref4.nodeData,
    triggerData = _ref4.triggerData,
    rest = _objectWithoutProperties(_ref4, ["nodeData", "triggerData"]);
  var widgets = useMemo(function () {
    return getInstrumentManagementWidgets(triggerData);
  }, [triggerData]);
  return /*#__PURE__*/React.createElement(NodeDatasContext.Provider, {
    value: nodeData
  }, /*#__PURE__*/React.createElement("div", {
    className: "instrument-management-form"
  }, /*#__PURE__*/React.createElement(RecordEditorForm, Object.assign({}, rest, {
    ArrayFieldTemplate: InstrumentManagementArrayFieldTemplate,
    ObjectFieldTemplate: InstrumentManagementObjectFieldTemplate,
    widgets: widgets
  }))));
};
export default InstrumentManagementForm;